import { ProtectedRoute } from "@/components/ProtectedRoute";
import { GetProjectNameDocument } from "@/generated/graphql";
import { ProjectTrashPage } from "@/pages/project/ProjectTrashPage";
import { useQuery } from "@apollo/client/react";
import { createFileRoute, useParams } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/project/$projectId/trash")({
  component: ProtectedProjectTrashPage,
});

function ProtectedProjectTrashPage() {
  const params = useParams({ from: "/admin/project/$projectId/trash" });
  const projectId = params.projectId;

  const { data: projectNameData } = useQuery(GetProjectNameDocument, {
    variables: { id: projectId },
  });

  const projectName = projectNameData?.project?.name ?? "";

  return (
    <ProtectedRoute>
      <ProjectTrashPage projectId={projectId} displayName={projectName} />
    </ProtectedRoute>
  );
}
